export const SEARCH_REQUEST = 'SEARCH_REQUEST';
export const SEARCH_SUCCESS = 'SEARCH_SUCCESS';
export const SEARCH_FAILURE = 'SEARCH_FAILURE';

export const SEARCH_BY_TYPE_REQUEST = 'SEARCH_BY_TYPE_REQUEST';
export const SEARCH_BY_TYPE_SUCCESS = 'SEARCH_BY_TYPE_SUCCES';
export const SEARCH_BY_TYPE_FAILURE = 'SEARCH_BY_TYPE_FAILURE';

export const SEARCH_VALUE_BY_TYPE_REQUEST = 'SEARCH_VALUE_BY_TYPE_REQUEST';
export const SEARCH_VALUE_BY_TYPE_SUCCESS = 'SEARCH_VALUE_BY_TYPE_SUCCES';
export const SEARCH_VALUE_BY_TYPE_FAILURE = 'SEARCH_VALUE_BY_TYPE_FAILURE';

export const SEARCH_RELATIONS_REQUEST = 'SEARCH_RELATIONS_REQUEST';
export const SEARCH_RELATIONS_SUCCESS = 'SEARCH_RELATIONS_SUCCES';
export const SEARCH_RELATIONS_FAILURE = 'SEARCH_RELATIONS_FAILURE';

export const CLEAR_SEARCH = 'CLEAR_SEARCH';

export const CLEAR_SEARCH_RESULT = 'CLEAR_SEARCH_RESULT';

export const SEARCH_FILTERS_REQUEST = 'SEARCH_FILTERS_REQUEST';
export const SEARCH_FILTERS_REQUEST_SUCCESS = 'SEARCH_FILTERS_REQUEST_SUCCESS';
export const SEARCH_FILTERS_REQUEST_FAILURE = 'SEARCH_FILTERS_REQUEST_FAILURE';

export const SHOULD_REFETCH = 'SHOULD_REFETCH';
